import { TDispatch } from '../type';

export type TTmsState = { access: boolean };

export const tmsReducer = (state: TTmsState, { type, payload }: TDispatch): TTmsState => {
  switch (type) {
    case 'set_tms_flagr':
      return {
        ...state,
        access: payload as boolean,
      };
    default:
      return state;
  }
};

tmsReducer.key = 'tms';
tmsReducer.initialState = {
  access: false,
};

export default { tmsReducer };
